import { IconFn, IconSvg } from "../createIcon";

export const CodeIcon: IconFn = ({ color = "#F56B55", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 48, height: 45 }} {...props}>
    <path
      d="M44.3858 1.00586H3.61417C2.15036 1.00586 0.959961 2.19779 0.959961 3.65853V40.501C0.959961 41.9618 2.15036 43.1537 3.61417 43.1537H44.3873C45.8496 43.1537 47.0415 41.9633 47.0415 40.501V3.65853C47.04 2.19779 45.8496 1.00586 44.3858 1.00586ZM3.61417 2.54186H44.3873C45.0032 2.54186 45.504 3.04259 45.504 3.65853V8.64439H2.49596V3.65853C2.49596 3.04259 2.9967 2.54186 3.61417 2.54186ZM44.3858 41.6177H3.61417C2.9967 41.6177 2.49596 41.117 2.49596 40.501V10.1804H45.504V40.501C45.504 41.117 45.0032 41.6177 44.3858 41.6177Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.209961 3.65853C0.209961 1.78358 1.73615 0.255859 3.61417 0.255859H44.3858C46.2639 0.255859 47.7895 1.78356 47.7915 3.65774V40.501C47.7915 42.3781 46.2632 43.9037 44.3873 43.9037H3.61417C1.73615 43.9037 0.209961 42.376 0.209961 40.501V3.65853ZM3.61417 1.75586C2.56457 1.75586 1.70996 2.61201 1.70996 3.65853V40.501C1.70996 41.5475 2.56458 42.4037 3.61417 42.4037H44.3873C45.4359 42.4037 46.2915 41.5485 46.2915 40.501V3.65932C46.2904 2.61203 45.4352 1.75586 44.3858 1.75586H3.61417ZM3.61417 3.29186C3.41024 3.29186 3.24596 3.45748 3.24596 3.65853V7.89439H44.754V3.65853C44.754 3.45681 44.589 3.29186 44.3873 3.29186H3.61417ZM1.74596 3.65853C1.74596 2.62771 2.58316 1.79186 3.61417 1.79186H44.3873C45.4174 1.79186 46.254 2.62838 46.254 3.65853V9.39439H1.74596V3.65853ZM1.74596 9.43039H46.254V40.501C46.254 41.5318 45.4168 42.3677 44.3858 42.3677H3.61417C2.58315 42.3677 1.74596 41.5318 1.74596 40.501V9.43039ZM3.24596 10.9304V40.501C3.24596 40.7021 3.41024 40.8677 3.61417 40.8677H44.3858C44.5897 40.8677 44.754 40.7021 44.754 40.501V10.9304H3.24596Z"
      fill={color}
    />
    <path
      d="M6.16405 7.03709C6.83337 7.03709 7.37596 6.4945 7.37596 5.82518C7.37596 5.15587 6.83337 4.61328 6.16405 4.61328C5.49474 4.61328 4.95215 5.15587 4.95215 5.82518C4.95215 6.4945 5.49474 7.03709 6.16405 7.03709Z"
      fill={color}
    />
    <path
      d="M10.0068 7.03709C10.6761 7.03709 11.2187 6.4945 11.2187 5.82518C11.2187 5.15587 10.6761 4.61328 10.0068 4.61328C9.33751 4.61328 8.79492 5.15587 8.79492 5.82518C8.79492 6.4945 9.33751 7.03709 10.0068 7.03709Z"
      fill={color}
    />
    <path
      d="M13.8516 7.03709C14.5209 7.03709 15.0635 6.4945 15.0635 5.82518C15.0635 5.15587 14.5209 4.61328 13.8516 4.61328C13.1822 4.61328 12.6396 5.15587 12.6396 5.82518C12.6396 6.4945 13.1822 7.03709 13.8516 7.03709Z"
      fill={color}
    />
    <path
      d="M17.7313 19.3867L9.81934 25.6029L17.7313 31.8222L18.679 30.6133L12.3061 25.6029L18.679 20.5956L17.7313 19.3867Z"
      fill={color}
      stroke={color}
    />
    <path
      d="M29.3203 20.5956L35.6932 25.6029L29.3203 30.6133L30.268 31.8222L38.18 25.6029L30.268 19.3867L29.3203 20.5956Z"
      fill={color}
      stroke={color}
    />
    <path
      d="M20.6444 35.8781L22.1348 36.25L27.355 15.328L25.8646 14.9562L20.6444 35.8781Z"
      fill={color}
      stroke={color}
    />
  </IconSvg>
);
